import React, {useEffect, useState} from "react";
import {BASE_URLS} from "../../config/urls";
import CalculatorDropdown from "./CalculatorDropdown";
import "../styles/dropdown.scss";

interface SendCityAndStoreProps {
    handleSendCity: (city: string) => void;
    handleStore: (store: string) => void;
    location: string;
}

const baseStores = ["Wildberries", "Ozon", "Яндекс Маркет"];

const SendCityAndStore: React.FC<SendCityAndStoreProps> = ({
                                                               handleStore,
                                                               handleSendCity,
                                                               location
                                                           }) => {
    const [storeIndex, setStoreIndex] = useState(0);

    const stores =
        location === "admin" ? [...baseStores, ""] : baseStores;

    const [destinationCities, setDestinationCities] = useState<string[]>([]);
    const [destinationIndex, setDestinationIndex] = useState(0);

    function handleStoreIndex(index: number) {
        setStoreIndex(index);
        const store = stores[index];
        handleStore(store);
    }

    function handleDestinationIndex(index: number) {
        setDestinationIndex(index);
        const city = destinationCities[index];
        handleSendCity(city);
    }

    useEffect(() => {
        const store = stores[storeIndex];

        if (!store) {
            setDestinationCities([]);
            setDestinationIndex(0);
            return;
        }

        const fetchCities = async () => {
            try {
                const resp = await fetch(
                    `${BASE_URLS.api}/price_request/cities?store=${encodeURIComponent(store)}`,
                    {
                        headers: {
                            Accept: "application/json",
                        },
                    }
                );

                if (!resp.ok) {
                    setDestinationCities([]);
                    setDestinationIndex(0);
                    return;
                }

                const data: string[] = await resp.json();
                const cities = location === "admin" ? [...data, ""] : data;

                setDestinationCities(cities);
                setDestinationIndex(0);

                if (cities.length > 0 && cities[0]) {
                    // это норм, потому что вызывается только
                    // при смене склада (storeIndex), а не при клике по городу
                    handleSendCity(cities[0]);
                }
            } catch (e) {
                console.error("Ошибка загрузки городов назначения:", e);
                setDestinationCities([]);
                setDestinationIndex(0);
            }
        };

        fetchCities();
        // 🔴 главное — без handleSendCity в зависимостях
    }, [storeIndex, location]);   // или вообще только [storeIndex], если location не меняется


    return (
        <div className="page_content" style={{flexFlow: "column"}}>

            <label className="calculator_label">Склад: </label>
            <CalculatorDropdown
                handleSelectClick={handleStoreIndex}
                items={stores}
                selectTitle={stores[storeIndex]}
            />

            <label className="calculator_label">Город назначения: </label>
            <CalculatorDropdown
                handleSelectClick={handleDestinationIndex}
                items={destinationCities}
                selectTitle={destinationCities[destinationIndex] || ""}
            />
        </div>
    );
};

export default SendCityAndStore;
